import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { PageSizes } from "../../../common/constants";
import { EntityIdObject, EntityObject } from "../../../common/types";
import {
  CertificateVehicleCategory,
  CertificateVehicleCategoryFilterPageRequest,
  CertificateVehicleCategoryFilterPageResult,
  CreateUpdateCertificateVehicleCategory,
} from "./types";

const FILTER_VEHICLE_CATEGORIES = ApiRequestAdapter.create("/vehicle-categories", HttpMethod.GET);
const CREATE_VEHICLE_CATEGORY = ApiRequestAdapter.create("/vehicle-categories", HttpMethod.POST);
const UPDATE_VEHICLE_CATEGORY = ApiRequestAdapter.create("/vehicle-categories/{0}", HttpMethod.PUT);
const DELETE_VEHICLE_CATEGORY = ApiRequestAdapter.create("/vehicle-categories/{0}", HttpMethod.DELETE);

export const vehicleCategoryApi = {
  filterVehicleCategories: (
    request: CertificateVehicleCategoryFilterPageRequest,
  ): AxiosPromise<CertificateVehicleCategoryFilterPageResult> => {
    return apiService.get(FILTER_VEHICLE_CATEGORIES.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  createVehicleCategory: (
    request: CreateUpdateCertificateVehicleCategory,
  ): AxiosPromise<CertificateVehicleCategory> => {
    return apiService.post(CREATE_VEHICLE_CATEGORY.url, request);
  },
  updateVehicleCategory: (
    request: EntityObject<CreateUpdateCertificateVehicleCategory>,
  ): AxiosPromise<CertificateVehicleCategory> => {
    return apiService.put(UPDATE_VEHICLE_CATEGORY.getParametrizedUrl(request.id), request.object);
  },
  deleteVehicleCategory: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_VEHICLE_CATEGORY.getParametrizedUrl(request.id));
  },
};

export const DEFAULT_VEHICLE_CATEGORY_QUERY_PARAMS: Required<CertificateVehicleCategoryFilterPageRequest> = {
  categories: [],
  keyword: "",
  pageIndex: 0,
  pageSize: PageSizes.LARGE,
};
